import { defineStore } from "pinia";
import { ref } from "vue";

const ALLOWED_DOMAINS = ["ispace.kz"];
const isCaptchaAvailable = ALLOWED_DOMAINS.some(
    (domain) =>
        window.location.hostname === domain || window.location.hostname.endsWith("." + domain),
);

function waitTurnstile() {
    return new Promise((resolve, reject) => {
        // @ts-expect-error cause it's global variable
        if (window.turnstile) return resolve(window.turnstile);

        const interval = setInterval(() => {
            // @ts-expect-error cause it's global variable
            if (window.turnstile) {
                clearInterval(interval);
                // @ts-expect-error cause it's global variable
                resolve(window.turnstile);
            }
        }, 50);

        setTimeout(() => {
            clearInterval(interval);
            reject(new Error("Turnstile timeout: script failed to initialize in time"));
        }, 6000);
    });
}

export const useCaptchaStore = defineStore("captcha", () => {
    const isCaptchaSuccess = ref(false);
    const isCaptchaScriptAlreadyAdded = ref(false);

    function addScriptToHTML() {
        if (!isCaptchaAvailable) {
            isCaptchaSuccess.value = true;
            return;
        }
        if (isCaptchaScriptAlreadyAdded.value) return;

        const CAPTCHA_SRC = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
        const scriptElement = document.createElement("script");
        scriptElement.setAttribute("src", CAPTCHA_SRC);
        scriptElement.setAttribute("defer", "");
        try {
            document.body.append(scriptElement);
            isCaptchaScriptAlreadyAdded.value = true;
        } catch (e) {
            console.error("error when tried to append script into body: ", e);
            isCaptchaSuccess.value = true;
        }
    }

    async function renderCaptcha() {
        try {
            if (!isCaptchaAvailable) {
                isCaptchaSuccess.value = true;
                return;
            }

            await waitTurnstile();
            // @ts-expect-error cause it's global variable
            window.turnstile.render("#turnstile-container", {
                sitekey: import.meta.env.VITE_TURNSTILE_SITE_KEY,
                callback: () => {
                    isCaptchaSuccess.value = true;
                },
                "error-callback": () => {
                    isCaptchaSuccess.value = false;
                },
                size: "flexible",
                theme: "light",
            });
        } catch (e) {
            console.error("Turnstile failed to render:", e);
            isCaptchaSuccess.value = true;
        }
    }

    return {
        isCaptchaSuccess,
        addScriptToHTML,
        renderCaptcha,
    };
});
